<div
  class="input__group"
  [style.--isp-input-field-width]="props.width$ | async"
>
  <ispui-input
    *ngIf="(isZoomed$ | async) === false; else zoomedInput"
    forceplaceholder
    [prefix]="props.prefix$ | async"
    [invalid]="showError"
    #ispuiInputElement
  >
    <input
      [placeholder]="props.placeholder$ | async"
      [maxlength]="props.maxLength"
      [required]="props.required"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [type]="'text'"
      [autocomplete]="props.autocomplete"
      [name]="key"
      [id]="id"
      #inputElement
    />
    <button
      *ngIf="props.zoomRows"
      class="button"
      type="button"
      slot="icon"
      data-ispui-tooltip-placement="topLeft"
      [attr.data-ispui-tooltip-text]="props.zoomHint$ | async"
      [tabIndex]="props.tabindex"
      (click)="toggleZoom()"
    >
      <isp-svg-icon [name]="zoomButtonIcon"></isp-svg-icon>
    </button>
    <button
      *ngIf="props.unlimited"
      class="button"
      type="button"
      slot="icon"
      (click)="setUnlimitedValue()"
    >
      <isp-svg-icon name="ff-unlimit-a"></isp-svg-icon>
    </button>
    <span
      *ngIf="props.postfix$ | async as postfix"
      class="postfix"
      slot="icon"
      >{{ postfix }}</span
    >
  </ispui-input>
</div>

<ng-template #zoomedInput>
  <ispui-textarea forceplaceholder [invalid]="showError">
    <textarea
      class="textarea"
      [tabindex]="props.tabindex || 0"
      [required]="props.required"
      [(ngModel)]="controlValue"
      [rows]="props.zoomRows"
      [placeholder]="props.placeholder$ | async"
      [disabled]="props.disabled"
      [id]="id"
      [name]="key"
      (blur)="handleTextareaBlur()"
    >
    </textarea>
    <button
      class="button button_absolute"
      type="button"
      slot="icon"
      data-ispui-tooltip-placement="topLeft"
      [attr.data-ispui-tooltip-text]="props.zoomHint$ | async"
      [tabIndex]="props.tabindex"
      (click)="toggleZoom()"
    >
      <isp-svg-icon [name]="zoomButtonIcon"></isp-svg-icon>
    </button>
  </ispui-textarea>
</ng-template>
